var be = Object.defineProperty, fe = Object.defineProperties;
var ke = Object.getOwnPropertyDescriptors;
var V = Object.getOwnPropertySymbols;
var Q = Object.prototype.hasOwnProperty, X = Object.prototype.propertyIsEnumerable;
var K = (e, o, r) => o in e ? be(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, n = (e, o) => {
  for (var r in o || (o = {}))
    Q.call(o, r) && K(e, r, o[r]);
  if (V)
    for (var r of V(o))
      X.call(o, r) && K(e, r, o[r]);
  return e;
}, u = (e, o) => fe(e, ke(o));
var g = (e, o) => {
  var r = {};
  for (var s in e)
    Q.call(e, s) && o.indexOf(s) < 0 && (r[s] = e[s]);
  if (e != null && V)
    for (var s of V(e))
      o.indexOf(s) < 0 && X.call(e, s) && (r[s] = e[s]);
  return r;
};
import { jsx as a, jsxs as xe } from "react/jsx-runtime";
import { useContext as ve, createContext as ye } from "react";
import { b as U, g as Z } from "./get-size-rXzn3RsE.js";
import { f as B, e as T, g as L, h as O, B as j, p as ee, l as $, j as ge } from "./factory--gUH4vxz.js";
import { g as oe, a as re } from "./get-auto-contrast-value-DVijeHyW.js";
import { I as _e, a as Ie, b as we } from "./InputsGroupFieldset-SvPez8e6.js";
import { U as Pe } from "./UnstyledButton-jTBAFmjC.js";
import { c as Ne } from "./create-optional-context-CQ2ahjKQ.js";
import { u as se } from "./use-uncontrolled-J2aphITS.js";
import { I as ne } from "./Input-Ccccf9Ny.js";
import { r as Y } from "./rem-CMQJ_ZTp.js";
import { u as Re } from "./use-id-DjDiWRdO.js";
const ce = ye(null), Se = ce.Provider, te = () => ve(ce), [ze, Ge] = Ne();
var ae = { card: "m_26775b0a" };
const Ve = {
  withBorder: !0
}, $e = O((e, { radius: o }) => ({
  card: {
    "--card-radius": U(o)
  }
})), W = B((e, o) => {
  const r = T("CheckboxCard", Ve, e), x = r, {
    classNames: s,
    className: t,
    style: l,
    styles: i,
    unstyled: c,
    vars: h,
    checked: v,
    mod: d,
    withBorder: _,
    value: I,
    onClick: b,
    defaultChecked: f,
    onChange: p
  } = x, k = g(x, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "checked",
    "mod",
    "withBorder",
    "value",
    "onClick",
    "defaultChecked",
    "onChange"
  ]), w = L({
    name: "CheckboxCard",
    classes: ae,
    props: r,
    className: t,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: h,
    varsResolver: $e,
    rootSelector: "card"
  }), m = te(), P = typeof v == "boolean" ? v : m ? m.value.includes(I || "") : void 0, [C, y] = se({
    value: P,
    defaultValue: f,
    finalValue: !1,
    onChange: p
  });
  return /* @__PURE__ */ a(ze, { value: { checked: C }, children: /* @__PURE__ */ a(
    Pe,
    u(n(n({
      ref: o,
      mod: [{ "with-border": _, checked: C }, d]
    }, w("card")), k), {
      role: "checkbox",
      "aria-checked": C,
      onClick: (R) => {
        b == null || b(R), m == null || m.onChange(I || ""), y(!C);
      }
    })
  ) });
});
W.displayName = "@mantine/core/CheckboxCard";
W.classes = ae;
const Be = {}, E = B((e, o) => {
  const b = T("CheckboxGroup", Be, e), { value: r, defaultValue: s, onChange: t, size: l, wrapperProps: i, children: c, readOnly: h } = b, v = g(b, ["value", "defaultValue", "onChange", "size", "wrapperProps", "children", "readOnly"]), [d, _] = se({
    value: r,
    defaultValue: s,
    finalValue: [],
    onChange: t
  });
  return /* @__PURE__ */ a(Se, { value: { value: d, onChange: (f) => {
    const p = typeof f == "string" ? f : f.currentTarget.value;
    !h && _(
      d.includes(p) ? d.filter((k) => k !== p) : [...d, p]
    );
  }, size: l }, children: /* @__PURE__ */ a(
    ne.Wrapper,
    u(n(n({
      size: l,
      ref: o
    }, i), v), {
      labelElement: "div",
      __staticSelector: "CheckboxGroup",
      children: /* @__PURE__ */ a(_e, { role: "group", children: c })
    })
  ) });
});
E.classes = ne.Wrapper.classes;
E.displayName = "@mantine/core/CheckboxGroup";
function Te(s) {
  var t = s, { size: e, style: o } = t, r = g(t, ["size", "style"]);
  const l = e !== void 0 ? n({ width: Y(e), height: Y(e) }, o) : o;
  return /* @__PURE__ */ a(
    "svg",
    u(n({
      viewBox: "0 0 10 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: l,
      "aria-hidden": !0
    }, r), {
      children: /* @__PURE__ */ a(
        "path",
        {
          d: "M4 4.586L1.707 2.293A1 1 0 1 0 .293 3.707l3 3a.997.997 0 0 0 1.414 0l5-5A1 1 0 1 0 8.293.293L4 4.586z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    })
  );
}
function le(r) {
  var s = r, { indeterminate: e } = s, o = g(s, ["indeterminate"]);
  return e ? /* @__PURE__ */ a(
    "svg",
    u(n({
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 32 6",
      "aria-hidden": !0
    }, o), {
      children: /* @__PURE__ */ a("rect", { width: "32", height: "6", fill: "currentColor", rx: "3" })
    })
  ) : /* @__PURE__ */ a(Te, n({}, o));
}
var ie = { indicator: "m_5e5256ee", icon: "m_1b1c543a", "indicator--outline": "m_76e20374" };
const Ae = {
  icon: le
}, je = O(
  (e, { radius: o, color: r, size: s, iconColor: t, variant: l, autoContrast: i }) => {
    const c = ee({ color: r || e.primaryColor, theme: e }), h = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      indicator: {
        "--checkbox-size": Z(s, "checkbox-size"),
        "--checkbox-radius": o === void 0 ? void 0 : U(o),
        "--checkbox-color": l === "outline" ? h : $(r, e),
        "--checkbox-icon-color": t ? $(t, e) : re(i, e) ? oe({ color: r, theme: e, autoContrast: i }) : void 0
      }
    };
  }
), F = B((e, o) => {
  const r = T("CheckboxIndicator", Ae, e), A = r, {
    classNames: s,
    className: t,
    style: l,
    styles: i,
    unstyled: c,
    vars: h,
    icon: v,
    indeterminate: d,
    radius: _,
    color: I,
    iconColor: b,
    autoContrast: f,
    checked: p,
    mod: k,
    variant: w,
    disabled: m
  } = A, P = g(A, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "icon",
    "indeterminate",
    "radius",
    "color",
    "iconColor",
    "autoContrast",
    "checked",
    "mod",
    "variant",
    "disabled"
  ]), C = v, y = L({
    name: "CheckboxIndicator",
    classes: ie,
    props: r,
    className: t,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: h,
    varsResolver: je,
    rootSelector: "indicator"
  }), x = Ge(), R = typeof p == "boolean" || typeof d == "boolean" ? p || d : (x == null ? void 0 : x.checked) || !1;
  return /* @__PURE__ */ a(
    j,
    u(n(u(n({
      ref: o
    }, y("indicator", { variant: w })), {
      variant: w,
      mod: [{ checked: R, disabled: m }, k]
    }), P), {
      children: /* @__PURE__ */ a(C, n({ indeterminate: d }, y("icon")))
    })
  );
});
F.displayName = "@mantine/core/CheckboxIndicator";
F.classes = ie;
var de = { root: "m_bf2d988c", inner: "m_26062bec", input: "m_26063560", icon: "m_bf295423", "input--outline": "m_215c4542" };
const Ue = {
  labelPosition: "right",
  icon: le
}, Le = O(
  (e, { radius: o, color: r, size: s, iconColor: t, variant: l, autoContrast: i }) => {
    const c = ee({ color: r || e.primaryColor, theme: e }), h = c.isThemeColor && c.shade === void 0 ? `var(--mantine-color-${c.color}-outline)` : c.color;
    return {
      root: {
        "--checkbox-size": Z(s, "checkbox-size"),
        "--checkbox-radius": o === void 0 ? void 0 : U(o),
        "--checkbox-color": l === "outline" ? h : $(r, e),
        "--checkbox-icon-color": t ? $(t, e) : re(i, e) ? oe({ color: r, theme: e, autoContrast: i }) : void 0
      }
    };
  }
), S = B((e, o) => {
  const r = T("Checkbox", Ue, e), H = r, {
    classNames: s,
    className: t,
    style: l,
    styles: i,
    unstyled: c,
    vars: h,
    color: v,
    label: d,
    id: _,
    size: I,
    radius: b,
    wrapperProps: f,
    checked: p,
    labelPosition: k,
    description: w,
    error: m,
    disabled: P,
    variant: C,
    indeterminate: y,
    icon: x,
    rootRef: R,
    iconColor: A,
    onChange: z,
    autoContrast: Oe,
    mod: ue
  } = H, he = g(H, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "color",
    "label",
    "id",
    "size",
    "radius",
    "wrapperProps",
    "checked",
    "labelPosition",
    "description",
    "error",
    "disabled",
    "variant",
    "indeterminate",
    "icon",
    "rootRef",
    "iconColor",
    "onChange",
    "autoContrast",
    "mod"
  ]), N = te(), pe = I || (N == null ? void 0 : N.size), me = x, G = L({
    name: "Checkbox",
    props: r,
    classes: de,
    className: t,
    style: l,
    classNames: s,
    styles: i,
    unstyled: c,
    vars: h,
    varsResolver: Le
  }), { styleProps: Ce, rest: M } = ge(he), q = Re(_), D = N ? {
    checked: N.value.includes(M.value),
    onChange: (J) => {
      N.onChange(J), z == null || z(J);
    }
  } : {};
  return /* @__PURE__ */ a(
    Ie,
    u(n(n(u(n({}, G("root")), {
      __staticSelector: "Checkbox",
      __stylesApiProps: r,
      id: q,
      size: pe,
      labelPosition: k,
      label: d,
      description: w,
      error: m,
      disabled: P,
      classNames: s,
      styles: i,
      unstyled: c,
      "data-checked": D.checked || p || void 0,
      variant: C,
      ref: R,
      mod: ue
    }), Ce), f), {
      children: /* @__PURE__ */ xe(j, u(n({}, G("inner")), { mod: { "data-label-position": k }, children: [
        /* @__PURE__ */ a(
          j,
          u(n(n(u(n({
            component: "input",
            id: q,
            ref: o,
            checked: p,
            disabled: P,
            mod: { error: !!m, indeterminate: y }
          }, G("input", { focusable: !0, variant: C })), {
            onChange: z
          }), M), D), {
            type: "checkbox"
          })
        ),
        /* @__PURE__ */ a(me, n({ indeterminate: y }, G("icon")))
      ] }))
    })
  );
});
S.classes = n(n({}, de), we);
S.displayName = "@mantine/core/Checkbox";
S.Group = E;
S.Indicator = F;
S.Card = W;
export {
  S as C
};
